import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpClient from "../helpers/httpClient";

const initialState = {
  pizzaDoughs: {
    data: [],
    loading: false,
  },
  selectedPizzaDough: {
    data: {},
    loading: false,
  },
};

export const getPizzaDoughs = createAsyncThunk(
  "pizzaDough/getPizzaDoughs",
  async () => {
    try {
      const response = await httpClient.get("/web/pizza-dough");
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const createPizzaDough = createAsyncThunk(
  "pizzaDough/createPizzaDough",
  async (pizzaDough) => {
    try {
      const response = await httpClient.post("/web/pizza-dough", pizzaDough);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const updatePizzaDough = createAsyncThunk(
  "pizzaDough/updatePizzaDough",
  async (pizzaDough) => {
    try {
      const response = await httpClient.put(
        `/web/pizza-dough-update/${pizzaDough._id}`,
        pizzaDough.data
      );
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getPizzaDoughById = createAsyncThunk(
  "pizzaDough/getPizzaDoughById",
  async (id) => {
    try {
      const response = await httpClient.get(`/web/pizza-dough/${id}`);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

const pizzaDoughSlice = createSlice({
  name: "pizzaDough",
  initialState,
  reducers: {
    initiSelectedPizzaDough: (state) => {
      state.selectedPizzaDough.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPizzaDoughs.pending, (state) => {
        state.pizzaDoughs.loading = true;
      })
      .addCase(getPizzaDoughs.fulfilled, (state, action) => {
        state.pizzaDoughs.data = action.payload;
        state.pizzaDoughs.loading = false;
      })
      .addCase(getPizzaDoughs.rejected, (state) => {
        state.pizzaDoughs.loading = false;
      })
      .addCase(updatePizzaDough.pending, (state) => {
        state.pizzaDoughs.loading = true;
      })
      .addCase(updatePizzaDough.fulfilled, (state, action) => {
        state.pizzaDoughs.data = state.pizzaDoughs.data.map((pizzaDough) => {
          if (pizzaDough._id === action.payload._id) {
            return action.payload;
          }
          return pizzaDough;
        });
        state.pizzaDoughs.loading = false;
      })
      .addCase(updatePizzaDough.rejected, (state) => {
        state.pizzaDoughs.loading = false;
      })
      .addCase(getPizzaDoughById.pending, (state) => {
        state.selectedPizzaDough.loading = true;
      })
      .addCase(getPizzaDoughById.fulfilled, (state, action) => {
        state.selectedPizzaDough.data = action.payload;
        state.selectedPizzaDough.loading = false;
      })
      .addCase(getPizzaDoughById.rejected, (state) => {
        state.selectedPizzaDough.loading = false;
      })
      .addCase(createPizzaDough.pending, (state) => {
        state.pizzaDoughs.loading = true;
      })
      .addCase(createPizzaDough.fulfilled, (state, action) => {
        state.pizzaDoughs.data.push(action.payload);
        state.pizzaDoughs.loading = false;
      })
      .addCase(createPizzaDough.rejected, (state) => {
        state.pizzaDoughs.loading = false;
      });
  },
});

export const { initiSelectedPizzaDough } = pizzaDoughSlice.actions;

export default pizzaDoughSlice.reducer;
